// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/services/mrpService.ts
//  Planejamento de necessidades de materiais (MRP).
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';

const BASE = '/api/planejamento-mrp';

export interface MrpDemanda {
  produtoId: number;
  quantidade: number;
}

export interface MrpNecessidade {
  materiaPrimaId: number;
  necessidadeBruta: number;
  saldoDisponivel: number;
  necessidadeLiquida: number;
}

export interface MrpResultado {
  necessidades: MrpNecessidade[];
  produtosSemFicha: number[];
}

export const mrpService = {
  async calcular(demandas: MrpDemanda[]): Promise<MrpResultado> {
    const { data } = await apiClient.post<MrpResultado>(`${BASE}/calcular`, { demandas });
    return data;
  },

  /** Demanda das Ordens de Produção em aberto (o que falta produzir), por previsão de entrega. */
  async demandaOrdensAbertas(de?: string, ate?: string): Promise<MrpDemanda[]> {
    const { data } = await apiClient.get<MrpDemanda[]>(`${BASE}/demanda-ordens`, {
      params: { de: de || undefined, ate: ate || undefined },
    });
    return data;
  },

  /**
   * Demanda dos pedidos de venda (DAVs) em aberto emitidos nos últimos `dias` dias.
   * `somenteComFicha`: só produtos fabricados (com ficha técnica ativa).
   */
  async demandaPedidosAbertos(dias = 30, somenteComFicha = true): Promise<MrpDemanda[]> {
    const { data } = await apiClient.get<MrpDemanda[]>(`${BASE}/demanda-pedidos`, {
      params: { dias, somenteComFicha },
    });
    return data;
  },
};
